(function () {
  'use strict';

  var STORAGE_KEY = 'saway:gift-wizard:v1';
  var CART_MINI_SECTION_ID = 'xo-cart-mini';
  var PRODUCTS_PER_RESULT = 4;
  var PROFILE_KEYS = ['minimal', 'romantic', 'colorful', 'classic', 'statement', 'everyday'];
  var RING_SIZES = Array.from({ length: 14 }, function (_, index) {
    return String(index + 8);
  });
  var PROFILE_KEYWORDS = {
    minimal: ['minimal', 'sade', 'zarif', 'ince', 'temiz', 'net', 'sessiz', 'tek tas', 'tektaş', 'stud', 'kucuk', 'küçük', 'ultra ince'],
    romantic: ['romantik', 'pembe', 'kalp', 'ask', 'aşk', 'sevgi', 'duygu', 'naif', 'yonca', 'petal', 'bloom', 'vow', 'soul'],
    colorful: ['renk', 'renkli', 'mavi', 'yesil', 'yeşil', 'sari', 'sarı', 'safir', 'zumrut', 'zümrüt', 'lacivert', 'cok renkli', 'çok renkli'],
    classic: ['vintage', 'klasik', 'zamansiz', 'zamansız', 'halo', 'oval', 'cushion', 'emerald', 'zumrut kesim', 'zümrüt kesim', 'deniz kabugu', 'deniz kabuğu'],
    statement: ['statement', 'gosterisli', 'gösterişli', 'ihtisam', 'ihtişam', 'guclu', 'güçlü', 'hacimli', 'yogun', 'yoğun', 'iddiali', 'iddialı', 'cesur', 'dikkat', 'sahne', 'genis', 'geniş'],
    everyday: ['gunluk', 'günlük', 'her gun', 'her gün', 'kullanimi kolay', 'kullanması kolay', 'takip cik', 'takıp çık', 'halka', 'stud', 'su yolu', 'denge', 'dengeli'],
  };
  var STYLE_PROFILE_MAP = {
    minimal: 'minimal',
    vintage: 'classic',
    colorful: 'colorful',
    statement: 'statement',
    unsure: 'everyday',
  };
  var MOMENT_KEYWORDS = {
    daily: ['gunluk', 'günlük', 'her gun', 'her gün', 'kullanimi kolay', 'kullanması kolay', 'takip cik', 'takıp çık', 'sade', 'ince', 'kucuk', 'küçük', 'minimal'],
    specialOccasion: ['ozel', 'özel', 'parlak', 'isiltı', 'ışıltı', 'ihtisam', 'ihtişam', 'gosterisli', 'gösterişli', 'halo', 'tek tas', 'tektaş', 'guclu', 'güçlü'],
    memory: ['anlam', 'hatira', 'hatıra', 'kalp', 'ask', 'aşk', 'sevgi', 'tilsim', 'tılsım', 'vow', 'soul', 'pulse', 'ripple'],
    spring: ['bahar', 'doga', 'doğa', 'floral', 'cicek', 'çiçek', 'yaprak', 'renk', 'mavi', 'yesil', 'yeşil', 'pembe', 'sari', 'sarı'],
  };

  var QUESTIONS = [
    {
      key: 'style',
      kicker: 'Soru 1',
      title: 'Onun tarzını en iyi hangisi anlatır?',
      subtitle: 'Günlük seçimlerini düşün: sade mi, vintage mı, gösterişli mi?',
      options: [
        {
          value: 'minimal',
          label: 'Sade ve zarif',
          text: 'Temiz formlar, ince ışıltılar.',
          scores: { minimal: 3, everyday: 1 },
        },
        {
          value: 'vintage',
          label: 'Vintage',
          text: 'Nostaljik detaylar, zamansız bir zarafet.',
          scores: { classic: 3, romantic: 1 },
        },
        {
          value: 'colorful',
          label: 'Renkli ve neşeli',
          text: 'Canlı taşlar, enerjik bir görünüm.',
          scores: { colorful: 3, romantic: 1 },
        },
        {
          value: 'statement',
          label: 'Gösterişli',
          text: 'Girdiği yerde fark edilen parçalar.',
          scores: { statement: 3, classic: 1 },
        },
        {
          value: 'unsure',
          label: 'Emin değilim',
          text: 'Dengeli ve güvenli öneriler göster.',
          scores: { minimal: 1, romantic: 1, classic: 1, everyday: 1 },
        },
      ],
    },
    {
      key: 'moment',
      kicker: 'Soru 2',
      title: 'Bu hediye hangi ana eşlik etsin?',
      subtitle: 'Hediyenin onun hayatındaki yerini seç.',
      options: [
        {
          value: 'daily',
          label: 'Her gün yanında olsun',
          text: 'Takıp çıkabileceği güvenli seçimler.',
          scores: { everyday: 3, minimal: 2 },
        },
        {
          value: 'specialOccasion',
          label: 'Özel günlere eşlik etsin',
          text: 'Zarif ama hatırda kalır.',
          scores: { classic: 2, statement: 2 },
        },
        {
          value: 'memory',
          label: 'Anlamı saklı kalsın',
          text: 'Duygusu güçlü küçük detaylar.',
          scores: { romantic: 3, minimal: 1 },
        },
        {
          value: 'spring',
          label: 'Bahar enerjisi taşısın',
          text: 'Renkli, canlı ve taze.',
          scores: { colorful: 3, everyday: 1 },
        },
      ],
    },
    {
      key: 'piece',
      kicker: 'Soru 3',
      title: 'En çok hangi parça mutlu eder?',
      subtitle: 'Aklında özel bir parça varsa seç; emin değilsen dengeli bir seçki hazırlayalım.',
      options: [
        {
          value: 'ring',
          label: 'Yüzük',
          text: 'Özel ve kişisel bir hediye.',
          typePreference: 'ring',
          scores: { statement: 2, romantic: 1 },
        },
        {
          value: 'earring',
          label: 'Küpe',
          text: 'Yüzünü aydınlatan bir dokunuş.',
          typePreference: 'earring',
          scores: { classic: 1, everyday: 1 },
        },
        {
          value: 'necklace',
          label: 'Kolye',
          text: 'Anlamı kalbe yakın dursun.',
          typePreference: 'necklace',
          scores: { romantic: 1, classic: 1 },
        },
        {
          value: 'bracelet',
          label: 'Bileklik',
          text: 'Günlük stile kolayca karışır.',
          typePreference: 'bracelet',
          scores: { everyday: 2, minimal: 1 },
        },
        {
          value: 'set',
          label: 'Set',
          text: 'Tek hediyede tamamlanmış bir görünüm.',
          typePreference: 'set',
          scores: { classic: 2, statement: 1, colorful: 1 },
        },
        {
          value: 'unsure',
          label: 'Emin değilim',
          text: 'Güvenli ve dengeli öneriler göster.',
          typePreference: null,
          scores: { everyday: 1, minimal: 1, classic: 1 },
        },
      ],
    },
    {
      key: 'budget',
      kicker: 'Soru 4',
      title: 'Hangi bütçede kalalım?',
      subtitle: 'Sonuçlarda seçtiğin tutarın üzerindeki ürünleri göstermeyiz.',
      options: [
        {
          value: 'under2500',
          label: '2.500 TL altı',
          text: 'Daha ulaşılabilir seçenekler.',
          budget: { max: 250000 },
          scores: { minimal: 1, everyday: 1 },
        },
        {
          value: '2500to4500',
          label: '2.500 - 4.500 TL',
          text: 'Güçlü hediye aralığı.',
          budget: { min: 250000, max: 450000 },
          scores: { everyday: 1, romantic: 1 },
        },
        {
          value: '4500to7000',
          label: '4.500 - 7.000 TL',
          text: 'Daha iddialı seçimler.',
          budget: { min: 450000, max: 700000 },
          scores: { classic: 1, statement: 1 },
        },
        {
          value: 'over7000',
          label: '7.000 TL ve üzeri',
          text: 'Setler ve büyük jestler için.',
          budget: { min: 700000 },
          scores: { statement: 2, classic: 1 },
        },
        {
          value: 'flexible',
          label: 'Bütçem esnek',
          text: 'En anlamlı eşleşmeyi öne çıkar.',
          budget: null,
          scores: { romantic: 1, colorful: 1, statement: 1 },
        },
      ],
    },
  ];

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-mdgw-section]').forEach(initSection);
  }

  function initSection(section) {
    if (!section || section.dataset.mdgwInitialized === 'true') return;
    section.dataset.mdgwInitialized = 'true';

    var configEl = section.querySelector('[data-mdgw-config]');
    if (!configEl) return;

    var config = parseConfig(configEl);
    if (!config || !Array.isArray(config.profiles) || config.profiles.length === 0) return;

    var els = {
      quiz: section.querySelector('[data-mdgw-quiz]'),
      result: section.querySelector('[data-mdgw-result]'),
      stepLabel: section.querySelector('[data-mdgw-step-label]'),
      progressFill: section.querySelector('[data-mdgw-progress-fill]'),
      questionKicker: section.querySelector('[data-mdgw-question-kicker]'),
      questionTitle: section.querySelector('[data-mdgw-question-title]'),
      questionSubtitle: section.querySelector('[data-mdgw-question-subtitle]'),
      options: section.querySelector('[data-mdgw-options]'),
      back: section.querySelector('[data-mdgw-back]'),
      profileTitle: section.querySelector('[data-mdgw-profile-title]'),
      profileDescription: section.querySelector('[data-mdgw-profile-description]'),
      products: section.querySelector('[data-mdgw-products]'),
      combo: section.querySelector('[data-mdgw-combo]'),
      shuffle: section.querySelector('[data-mdgw-shuffle]'),
      restart: section.querySelector('[data-mdgw-restart]'),
      note: section.querySelector('[data-mdgw-note]'),
      noteCount: section.querySelector('[data-mdgw-note-count]'),
      saveNote: section.querySelector('[data-mdgw-save-note]'),
      checkout: section.querySelector('[data-mdgw-checkout]'),
      noteStatus: section.querySelector('[data-mdgw-note-status]'),
      emailForm: section.querySelector('.mdgw__email-form'),
      emailStatus: section.querySelector('[data-mdgw-email-status]'),
    };

    var productMap = buildProductMap(config);
    var state = loadState() || {
      step: 0,
      answers: {},
      result: null,
      offset: 0,
      addedToCart: false,
    };
    var catalogReady = false;

    normalizeState(state);

    loadCatalogProducts()
      .then(function (products) {
        if (!products.length) return;
        config.catalogProducts = products;
        productMap = buildProductMap(config);
        catalogReady = true;
        if (state.result) renderResult();
      })
      .catch(function () {
        catalogReady = true;
      });

    section.addEventListener('click', function (event) {
      var option = event.target.closest('[data-mdgw-answer]');
      if (option && section.contains(option)) {
        setAnswer(state, option.getAttribute('data-mdgw-answer'));
        advanceAfterAnswer();
        return;
      }

      var addProduct = event.target.closest('[data-mdgw-add-product]');
      if (addProduct && section.contains(addProduct)) {
        handleAddProduct(addProduct);
        return;
      }

      var addCombo = event.target.closest('[data-mdgw-add-combo]');
      if (addCombo && section.contains(addCombo)) {
        handleAddCombo(addCombo);
      }
    });

    section.addEventListener('change', function (event) {
      if (event.target.matches('[data-mdgw-ring-size], [data-mdgw-combo-size]')) {
        var card = event.target.closest('[data-mdgw-product-card], [data-mdgw-combo]');
        setStatus(card, '');
      }
    });

    if (els.back) {
      els.back.addEventListener('click', function () {
        if (state.step > 0) {
          state.step -= 1;
          saveState(state);
          renderQuestion();
          scrollToWizard(els.quiz);
        }
      });
    }

    if (els.shuffle) {
      els.shuffle.addEventListener('click', function () {
        state.offset = (state.offset || 0) + PRODUCTS_PER_RESULT;
        saveState(state);
        renderResult();
        scrollToWizard(els.products || els.result);
      });
    }

    if (els.restart) {
      els.restart.addEventListener('click', function () {
        state.step = 0;
        state.answers = {};
        state.result = null;
        state.offset = 0;
        state.addedToCart = false;
        saveState(state);
        renderQuestion();
        scrollToWizard(els.quiz);
      });
    }

    if (els.note) {
      els.note.addEventListener('input', updateNoteCount);
      updateNoteCount();
    }

    if (els.saveNote) {
      els.saveNote.addEventListener('click', function () {
        saveGiftNote(false);
      });
    }

    if (els.checkout) {
      els.checkout.addEventListener('click', function () {
        goToCheckout();
      });
    }

    setupEmailForm();

    if (state.result) {
      renderResult();
    } else {
      renderQuestion();
    }

    function advanceAfterAnswer() {
      if (state.step < QUESTIONS.length - 1) {
        state.step += 1;
        saveState(state);
        renderQuestion();
        scrollToWizard(els.quiz);
        return;
      }

      state.result = calculateResult(state.answers, config);
      state.offset = 0;
      state.addedToCart = false;
      saveState(state);
      renderResult();
      scrollToWizard(els.result);
    }

    function renderQuestion() {
      var question = QUESTIONS[state.step] || QUESTIONS[0];
      show(els.quiz, true);
      show(els.result, false);

      if (els.stepLabel) els.stepLabel.textContent = state.step + 1 + ' / ' + QUESTIONS.length;
      if (els.progressFill) els.progressFill.style.width = ((state.step + 1) / QUESTIONS.length) * 100 + '%';
      if (els.questionKicker) els.questionKicker.textContent = question.kicker;
      if (els.questionTitle) els.questionTitle.textContent = question.title;
      if (els.questionSubtitle) els.questionSubtitle.textContent = question.subtitle;

      if (els.options) {
        els.options.innerHTML = question.options
          .map(function (option) {
            var selected = state.answers[question.key] === option.value ? ' is-selected' : '';
            return (
              '<button class="mdgw__option' +
              selected +
              '" type="button" data-mdgw-answer="' +
              escapeAttr(option.value) +
              '">' +
              '<span class="mdgw__option-title">' +
              escapeHtml(option.label) +
              '</span>' +
              '<span class="mdgw__option-text">' +
              escapeHtml(option.text) +
              '</span>' +
              '</button>'
            );
          })
          .join('');
      }

      if (els.back) els.back.disabled = state.step === 0;
    }

    function renderResult() {
      if (!state.result) {
        renderQuestion();
        return;
      }

      var profile = getProfile(config, state.result.profileKey);
      if (!profile) {
        renderQuestion();
        return;
      }

      show(els.quiz, false);
      show(els.result, true);

      if (els.profileTitle) els.profileTitle.textContent = profile.title || 'Saway seçkisi';
      if (els.profileDescription) els.profileDescription.textContent = profile.description || '';

      var products = chooseProducts(profile, config, state);
      if (els.products) {
        els.products.innerHTML = products.length
          ? products.map(renderProductCard).join('')
          : renderEmptyResults(catalogReady);
      }
      if (els.shuffle) els.shuffle.hidden = products.length === 0;

      renderCombo(profile, chooseComboProducts(profile, config, state, products));
    }

    function renderCombo(profile, products) {
      if (!els.combo) return;

      var combo = getComboCopy(profile, state);
      products = uniqueProducts(products || []).filter(isAvailableProduct);
      if (products.length === 0) {
        els.combo.innerHTML = '';
        els.combo.hidden = true;
        return;
      }

      els.combo.hidden = false;
      els.combo.innerHTML =
        '<div class="mdgw__combo-head">' +
        '<div>' +
        '<p class="mdgw__combo-kicker">Kombin önerisi</p>' +
        '<h3 class="mdgw__combo-title">' +
        escapeHtml(combo.title) +
        '</h3>' +
        '<p class="mdgw__combo-text">' +
        escapeHtml(combo.description) +
        '</p>' +
        '</div>' +
        '<div class="mdgw__combo-actions">' +
        '<button class="mdgw__button mdgw__button--primary" type="button" data-mdgw-add-combo>Kombini sepete ekle</button>' +
        '</div>' +
        '</div>' +
        '<div class="mdgw__combo-products">' +
        products
          .map(function (product) {
            return renderComboItem(product);
          })
          .join('') +
        '</div>' +
        '<p class="mdgw__status" data-mdgw-status role="status"></p>';
    }

    function renderProductCard(product) {
      var title = formatProductTitle(product.title);
      var descriptionText = formatProductDescription(product.description);
      var description = descriptionText
        ? '<p class="mdgw__card-description">' + escapeHtml(descriptionText) + '</p>'
        : '';
      var image = product.image
        ? '<img src="' + escapeAttr(normalizeImageUrl(product.image)) + '" alt="' + escapeAttr(title) + '" loading="lazy">'
        : '';
      var ringSize = product.isRing
        ? '<div class="mdgw__size-field">' +
          '<span class="mdgw__size-label">Yüzük Ölçüsü</span>' +
          renderSizeSelect('data-mdgw-ring-size') +
          renderSizeGuideLink() +
          '</div>'
        : '';

      return (
        '<article class="mdgw__product-card" data-mdgw-product-card data-product-handle="' +
        escapeAttr(product.handle) +
        '">' +
        '<a class="mdgw__card-image" href="' +
        escapeAttr(product.url || '#') +
        '">' +
        image +
        '</a>' +
        '<div class="mdgw__card-body">' +
        '<span class="mdgw__card-meta">' +
        escapeHtml(product.type || 'Saway') +
        '</span>' +
        '<h3 class="mdgw__card-title"><a href="' +
        escapeAttr(product.url || '#') +
        '">' +
        escapeHtml(title) +
        '</a></h3>' +
        description +
        '<div class="mdgw__price">' +
        escapeHtml(product.priceText || '') +
        '</div>' +
        ringSize +
        '<div class="mdgw__card-actions">' +
        '<a class="mdgw__button mdgw__button--primary" href="' +
        escapeAttr(product.url || '#') +
        '">Ürünü incele</a>' +
        '<button class="mdgw__button mdgw__button--ghost" type="button" data-mdgw-add-product="' +
        escapeAttr(product.handle) +
        '">' +
        'Sepete ekle' +
        '</button>' +
        '</div>' +
        '<p class="mdgw__status" data-mdgw-status role="status"></p>' +
        '</div>' +
        '</article>'
      );
    }

    function renderEmptyResults(ready) {
      var pieceOption = getSelectedQuestionOption(state, 'piece');
      var budgetOption = getSelectedQuestionOption(state, 'budget');
      var message = ready
        ? 'Bu seçimlere ve bütçeye uygun ürün bulamadık. Bütçeyi esneterek ya da ürün tipini değiştirerek tekrar deneyebilirsin.'
        : 'Ürünler hazırlanıyor...';

      if (ready && pieceOption && pieceOption.typePreference === 'set' && budgetOption && budgetOption.budget && budgetOption.budget.max) {
        message = 'Bu bütçe aralığında set bulunmuyor. İstersen ürün tipi olarak emin değilim seçip bütçeye uygun parçaları görebilirsin.';
      }

      return (
        '<div class="mdgw__empty-results">' +
        '<p>' +
        escapeHtml(message) +
        '</p>' +
        '</div>'
      );
    }

    function renderComboItem(product) {
      var title = formatProductTitle(product.title);
      var image = product.image
        ? '<img src="' + escapeAttr(normalizeImageUrl(product.image)) + '" alt="' + escapeAttr(title) + '" loading="lazy">'
        : '<span aria-hidden="true"></span>';
      var ringSize = product.isRing
        ? '<div class="mdgw__combo-size">' +
          '<span class="mdgw__size-label">Yüzük Ölçüsü</span>' +
          renderSizeSelect('data-mdgw-combo-size', product.handle) +
          renderSizeGuideLink() +
          '</div>'
        : '';

      return (
        '<div class="mdgw__combo-item" data-combo-product-handle="' +
        escapeAttr(product.handle) +
        '">' +
        image +
        '<div>' +
        '<p class="mdgw__combo-name">' +
        escapeHtml(title) +
        '</p>' +
        '<p class="mdgw__combo-price">' +
        escapeHtml(product.priceText || '') +
        '</p>' +
        ringSize +
        '</div>' +
        '</div>'
      );
    }

    function renderSizeSelect(attribute, handle) {
      return (
        '<select class="mdgw__select" ' +
        attribute +
        (handle ? ' data-product-handle="' + escapeAttr(handle) + '"' : '') +
        ' aria-label="Yüzük ölçüsü">' +
        '<option value="">Ölçü seçin</option>' +
        RING_SIZES.map(function (size) {
          return '<option value="' + size + '">' + size + '</option>';
        }).join('') +
        '</select>'
      );
    }

    function renderSizeGuideLink() {
      return '<a class="mdgw__size-guide" href="' + escapeAttr(joinRoot('pages/yuzuk-olcusu-nasil-alinir')) + '">Ölçünü bilmiyor musun? Ölçü rehberi</a>';
    }

    async function handleAddProduct(button) {
      var handle = button.getAttribute('data-mdgw-add-product');
      var product = productMap.get(handle);
      var card = button.closest('[data-mdgw-product-card]');
      if (!product || !card) return;
      if (!isAvailableProduct(product)) {
        setStatus(card, 'Bu ürün şu anda stokta görünmüyor.', 'error');
        return;
      }

      var properties = {};
      if (product.isRing) {
        var select = card.querySelector('[data-mdgw-ring-size]');
        var size = select ? select.value : '';
        if (!size) {
          setStatus(card, 'Önce yüzük ölçüsünü seçmelisin.', 'error');
          if (select) select.focus();
          return;
        }
        properties['Yüzük Ölçüsü'] = size;
      }

      setStatus(card, '');
      setButtonLoading(button, true, 'Ekleniyor...');

      try {
        await addItemsToCart([
          {
            id: String(product.variantId),
            quantity: 1,
            properties: properties,
          },
        ]);
        state.addedToCart = true;
        saveState(state);
        setStatus(card, 'Sepete eklendi. İstersen aşağıdan not ekleyebilirsin.', 'success');
      } catch (error) {
        setStatus(card, error.message || 'Sepete eklenemedi.', 'error');
      } finally {
        setButtonLoading(button, false);
      }
    }

    async function handleAddCombo(button) {
      var comboBox = button.closest('[data-mdgw-combo]');
      var profile = getProfile(config, state.result && state.result.profileKey);
      var selectedProducts = profile ? chooseProducts(profile, config, state) : [];
      var products = profile ? chooseComboProducts(profile, config, state, selectedProducts) : [];
      if (!comboBox || products.length === 0) return;
      products = products.filter(isAvailableProduct);
      if (products.length === 0) {
        setStatus(comboBox, 'Bu kombin şu anda stokta görünmüyor.', 'error');
        return;
      }

      var items = [];
      var missingSelect = null;

      products.forEach(function (product) {
        var properties = {};

        if (product.isRing) {
          var select = comboBox.querySelector('[data-mdgw-combo-size][data-product-handle="' + cssAttr(product.handle) + '"]');
          var size = select ? select.value : '';
          if (!size && !missingSelect) missingSelect = select;
          if (size) properties['Yüzük Ölçüsü'] = size;
        }

        items.push({
          id: String(product.variantId),
          quantity: 1,
          properties: properties,
        });
      });

      if (missingSelect) {
        setStatus(comboBox, 'Kombindeki yüzük için ölçü seçmelisin.', 'error');
        missingSelect.focus();
        return;
      }

      setStatus(comboBox, '');
      setButtonLoading(button, true, 'Ekleniyor...');

      try {
        await addItemsToCart(items);
        state.addedToCart = true;
        saveState(state);
        setStatus(comboBox, 'Kombin sepete eklendi. İstersen aşağıdan not ekleyebilirsin.', 'success');
      } catch (error) {
        setStatus(comboBox, error.message || 'Kombin sepete eklenemedi.', 'error');
      } finally {
        setButtonLoading(button, false);
      }
    }

    async function addItemsToCart(items) {
      var response = await fetch(withJsonExtension(getRoute('cartAdd')), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items }),
      });

      if (!response.ok) {
        throw new Error(await getResponseError(response));
      }

      await response.json().catch(function () {
        return null;
      });
      await refreshCartState();
    }

    async function saveGiftNote(silent) {
      if (!els.note) return true;

      var note = els.note.value || '';
      if (note.length > 200) note = note.slice(0, 200);

      if (!silent) {
        setNoteStatus('');
        setButtonLoading(els.saveNote, true, 'Kaydediliyor...');
      }

      try {
        var response = await fetch(withJsonExtension(getRoute('cartUpdate')), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ note: note }),
        });

        if (!response.ok) throw new Error(await getResponseError(response));

        await refreshCartState();
        if (!silent) {
          setNoteStatus(note.trim() ? 'Not kaydedildi.' : 'Not alanı temizlendi.', 'success');
        }
        return true;
      } catch (error) {
        if (!silent) setNoteStatus(error.message || 'Not kaydedilemedi.', 'error');
        return false;
      } finally {
        if (!silent) setButtonLoading(els.saveNote, false);
      }
    }

    async function goToCheckout() {
      if (!els.checkout) return;
      setNoteStatus('');
      setButtonLoading(els.checkout, true, 'Hazırlanıyor...');

      var shouldSave = els.note && els.note.value.trim().length > 0;
      var saved = shouldSave ? await saveGiftNote(true) : true;

      setButtonLoading(els.checkout, false);

      if (!saved) {
        setNoteStatus('Not kaydedilemedi. İstersen notu silip devam edebilirsin.', 'error');
        return;
      }

      window.location.href = joinRoot('checkout');
    }

    async function refreshCartState() {
      var root = getRoot();
      var cartResponse = fetch(root + 'cart.js', { cache: 'no-store' }).then(function (response) {
        return response.json();
      });
      var sectionResponse = fetch(root + '?sections=' + CART_MINI_SECTION_ID, { cache: 'no-store' }).then(function (response) {
        return response.json();
      });

      var responses = await Promise.all([cartResponse, sectionResponse]);
      var cart = responses[0] || {};
      var sections = responses[1] || {};
      var cartMiniHtml = sections[CART_MINI_SECTION_ID];

      updateCartSize(cart.item_count || 0);
      replaceCartMini(cartMiniHtml);
      syncXoCartStore(cart.item_count || 0, cartMiniHtml);

      document.dispatchEvent(
        new CustomEvent('saway:cart-refreshed', {
          detail: { cart: cart, sections: sections },
        })
      );
    }

    function updateCartSize(itemCount) {
      document.querySelectorAll('xo-cart-size').forEach(function (el) {
        el.textContent = itemCount;
      });
    }

    function replaceCartMini(sectionHtml) {
      if (!sectionHtml) return;

      var current = document.querySelector('xo-cart-mini#' + CART_MINI_SECTION_ID);
      if (!current) return;

      var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var next = parsed.querySelector('xo-cart-mini#' + CART_MINI_SECTION_ID);
      if (next) current.innerHTML = next.innerHTML;
    }

    function syncXoCartStore(itemCount, sectionHtml) {
      if (!window.xoStore || typeof window.xoStore.set !== 'function') return;

      try {
        window.xoStore.set('xo-cart', function (currentState) {
          var sections = Object.assign({}, currentState && currentState.sections ? currentState.sections : {});
          if (sectionHtml) sections[CART_MINI_SECTION_ID] = sectionHtml;

          return Object.assign({}, currentState, {
            size: itemCount,
            sections: sections,
            changeLineLoading: -1,
          });
        })('gift-wizard/cart-sync');
      } catch (error) {
        // The drawer is still updated through DOM replacement above.
      }
    }

    async function loadCatalogProducts() {
      var response = await fetch(joinRoot('products.json?limit=250'), {
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return [];

      var data = await response.json().catch(function () {
        return null;
      });

      return ((data && data.products) || []).map(mapCatalogProduct).filter(Boolean);
    }

    function getRoute(key) {
      if (config.routes && config.routes[key]) return config.routes[key];
      if (window.routes) {
        if (key === 'cartAdd' && window.routes.cart_add_url) return window.routes.cart_add_url;
        if (key === 'cartUpdate' && window.routes.cart_update_url) return window.routes.cart_update_url;
        if (key === 'cart' && window.routes.cart_url) return window.routes.cart_url;
      }
      if (key === 'cartAdd') return joinRoot('cart/add');
      if (key === 'cartUpdate') return joinRoot('cart/update');
      if (key === 'cart') return joinRoot('cart');
      return getRoot();
    }

    function getRoot() {
      if (config.routes && config.routes.root) return ensureTrailingSlash(config.routes.root);
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return ensureTrailingSlash(window.Shopify.routes.root);
      }
      return '/';
    }

    function joinRoot(path) {
      return getRoot() + String(path || '').replace(/^\//, '');
    }

    function withJsonExtension(url) {
      if (!url) return '';
      return /\.js(\?|$)/.test(url) ? url : url.replace(/\/$/, '') + '.js';
    }

    function updateNoteCount() {
      if (!els.note || !els.noteCount) return;
      if (els.note.value.length > 200) {
        els.note.value = els.note.value.slice(0, 200);
      }
      els.noteCount.textContent = els.note.value.length + ' / 200';
    }

    function setNoteStatus(message, type) {
      if (!els.noteStatus) return;
      els.noteStatus.textContent = message || '';
      els.noteStatus.classList.toggle('is-error', type === 'error');
      els.noteStatus.classList.toggle('is-success', type === 'success');
    }

    function setupEmailForm() {
      if (!els.emailForm || els.emailForm.dataset.mdgwEmailReady === 'true') return;
      els.emailForm.dataset.mdgwEmailReady = 'true';

      var iframeName = 'mdgw-email-frame-' + (config.sectionId || Date.now());
      var iframe = document.createElement('iframe');
      iframe.name = iframeName;
      iframe.hidden = true;
      iframe.setAttribute('aria-hidden', 'true');
      section.appendChild(iframe);
      els.emailForm.setAttribute('target', iframeName);

      els.emailForm.addEventListener('submit', function () {
        var button = els.emailForm.querySelector('button[type="submit"]');
        setButtonLoading(button, true, 'Kaydediliyor...');
        if (els.emailStatus) els.emailStatus.hidden = true;

        window.setTimeout(function () {
          setButtonLoading(button, false);
          if (els.emailStatus) els.emailStatus.hidden = false;
        }, 900);
      });
    }

    function scrollToWizard(target) {
      if (!target || typeof target.getBoundingClientRect !== 'function') return;
      window.setTimeout(function () {
        var offset = getViewportTopOffset();
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: 'smooth',
        });
      }, 40);
    }
  }

  function getViewportTopOffset() {
    var fallback = window.matchMedia('(max-width: 767px)').matches ? 118 : 96;
    var stickyOffset = 0;

    document.querySelectorAll('header, .xo-header, .shopify-section-header-sticky, sticky-header').forEach(function (element) {
      var style = window.getComputedStyle(element);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;

      var rect = element.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 8) return;
      stickyOffset = Math.max(stickyOffset, rect.bottom);
    });

    return Math.max(stickyOffset + 18, fallback);
  }

  function parseConfig(configEl) {
    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      return null;
    }
  }

  function normalizeState(state) {
    state.step = Number.isInteger(state.step) ? Math.max(0, Math.min(QUESTIONS.length - 1, state.step)) : 0;
    state.answers = state.answers && typeof state.answers === 'object' ? state.answers : {};
    state.offset = Number.isFinite(state.offset) ? state.offset : 0;
  }

  function setAnswer(state, value) {
    var question = QUESTIONS[state.step];
    if (!question) return;
    state.answers[question.key] = value;
  }

  function calculateResult(answers, config) {
    var scores = PROFILE_KEYS.reduce(function (memo, key) {
      memo[key] = 0;
      return memo;
    }, {});

    QUESTIONS.forEach(function (question) {
      var selected = getSelectedOption(question, answers[question.key]);
      if (!selected || !selected.scores) return;
      Object.keys(selected.scores).forEach(function (key) {
        scores[key] = (scores[key] || 0) + selected.scores[key];
      });
    });

    var profileOrder = (config.profiles || []).map(function (profile) {
      return profile.key;
    });

    var winner = profileOrder.reduce(
      function (best, key, index) {
        var score = scores[key] || 0;
        if (!best || score > best.score) return { key: key, score: score, index: index };
        return best;
      },
      null
    );

    return {
      profileKey: winner ? winner.key : (config.profiles[0] && config.profiles[0].key),
      answers: Object.assign({}, answers),
      createdAt: Date.now(),
    };
  }

  function chooseProducts(profile, config, state) {
    var products = buildProductPool(config, profile);
    var pieceOption = getSelectedQuestionOption(state, 'piece');
    var preferredHandles = getProfileHandles(profile);

    products = filterProductsForAnswers(products, state, { applyPiece: true });

    if (products.length === 0) return [];

    var scored = products
      .map(function (product, index) {
        return {
          product: product,
          index: index,
          score: scoreProduct(product, state, preferredHandles),
        };
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.index - b.index;
      })
      .map(function (entry) {
        return entry.product;
      });

    return takeRotated(scored, PRODUCTS_PER_RESULT, state.offset || 0);
  }

  function chooseComboProducts(profile, config, state, selectedProducts) {
    var pieceOption = getSelectedQuestionOption(state, 'piece');
    var budgetOption = getSelectedQuestionOption(state, 'budget');
    var budget = budgetOption && budgetOption.budget;
    var pool = filterProductsForAnswers(buildProductPool(config, profile), state, { applyPiece: false });
    var profileCombo = filterProductsForAnswers((profile.combo && profile.combo.products) || [], state, { applyPiece: false });

    if (pieceOption && pieceOption.typePreference === 'set') {
      return [];
    }

    if (pieceOption && pieceOption.typePreference) {
      return buildComplementaryCombo(pool, selectedProducts || [], pieceOption.typePreference, budget);
    }

    return buildBalancedCombo(profileCombo.length ? profileCombo : pool, budget, state.offset || 0);
  }

  function buildComplementaryCombo(pool, selectedProducts, preference, budget) {
    var combo = [];
    var nonSetPool = uniqueProducts(pool).filter(function (product) {
      return !product.isSet;
    });
    var excludedCategory = preference;

    var complementMap = {
      ring: ['earring', 'bracelet', 'necklace'],
      earring: ['bracelet', 'ring', 'necklace'],
      necklace: ['earring', 'bracelet', 'ring'],
      bracelet: ['ring', 'earring', 'necklace'],
    };
    var complements = complementMap[preference] || [];

    complements.forEach(function (type) {
      if (combo.length >= 3) return;
      var match = nonSetPool.find(function (product) {
        return canAddComboProduct(combo, product, budget, excludedCategory) && matchesProductType(product, type);
      });
      if (match) addComboCandidate(combo, match, budget, excludedCategory);
    });

    nonSetPool.forEach(function (product) {
      if (combo.length >= 3) return;
      addComboCandidate(combo, product, budget, excludedCategory);
    });

    return combo.length >= 2 ? combo.slice(0, 3) : [];
  }

  function buildBalancedCombo(products, budget, offset) {
    var combo = [];
    var rotated = rotateProducts(uniqueProducts(products), offset || 0);

    rotated.forEach(function (product) {
      if (combo.length >= 3) return;
      addComboCandidate(combo, product, budget);
    });

    return combo.length >= 2 ? combo : [];
  }

  function addComboCandidate(combo, product, budget, excludedCategory) {
    if (!canAddComboProduct(combo, product, budget, excludedCategory)) return false;
    combo.push(product);
    return true;
  }

  function canAddComboProduct(combo, product, budget, excludedCategory) {
    if (!product || combo.some(sameHandle(product))) return false;
    if (product.isSet || combo.some(function (item) { return item.isSet; })) return false;

    var category = getProductCategory(product);
    if (excludedCategory && category === excludedCategory) return false;
    if (category && combo.some(function (item) { return getProductCategory(item) === category; })) return false;
    if (budget && budget.max && getComboTotal(combo) + (product.price || 0) > budget.max) return false;

    return true;
  }

  function getComboTotal(products) {
    return (products || []).reduce(function (sum, product) {
      return sum + (product.price || 0);
    }, 0);
  }

  function rotateProducts(products, offset) {
    if (!products.length) return [];
    var start = Math.abs(offset || 0) % products.length;
    return products.slice(start).concat(products.slice(0, start));
  }

  function getComboCopy(profile, state) {
    var pieceOption = getSelectedQuestionOption(state, 'piece');
      var fallbackTitle = profile.combo && profile.combo.title ? profile.combo.title : 'Hediye Kombini';
    var fallbackDescription = profile.combo && profile.combo.description
      ? profile.combo.description
      : 'Birlikte kullanıldığında dengeli görünen Saway parçaları.';

    if (!pieceOption || !pieceOption.typePreference) {
      return { title: fallbackTitle, description: fallbackDescription };
    }

    var copy = {
      ring: {
        title: 'Yüzükle Uyumlu Parçalar',
        description: 'Seçtiğin yüzüğe eşlik edebilecek küpe, bileklik veya kolye önerileri.',
      },
      earring: {
        title: 'Küpeyle Uyumlu Parçalar',
        description: 'Seçtiğin küpeyle birlikte kullanılabilecek yüzük, bileklik veya kolye önerileri.',
      },
      necklace: {
        title: 'Kolyeyle Uyumlu Parçalar',
        description: 'Seçtiğin kolyeyi destekleyecek küpe, yüzük veya bileklik önerileri.',
      },
      bracelet: {
        title: 'Bileklikle Uyumlu Parçalar',
        description: 'Seçtiğin bileklikle birlikte düşünülebilecek yüzük, küpe veya kolye önerileri.',
      },
      set: {
        title: 'Set Ağırlıklı Hediye Seçkisi',
        description: 'Tek hediyede tamamlanmış görünüm isteyen anneler için Saway setleri.',
      },
    }[pieceOption.typePreference];

    return copy || { title: fallbackTitle, description: fallbackDescription };
  }

  function buildProductPool(config, preferredProfile) {
    var profileProducts = preferredProfile
      ? (preferredProfile.products || []).concat((preferredProfile.combo && preferredProfile.combo.products) || [])
      : [];
    var otherProducts = [];

    (config.profiles || []).forEach(function (profile) {
      if (preferredProfile && profile.key === preferredProfile.key) return;
      otherProducts = otherProducts.concat(profile.products || []);
      if (profile.combo && Array.isArray(profile.combo.products)) {
        otherProducts = otherProducts.concat(profile.combo.products);
      }
    });

    return uniqueProducts(profileProducts.concat(config.catalogProducts || [], config.setProducts || [], otherProducts)).filter(isAvailableProduct);
  }

  function getProfileHandles(profile) {
    var handles = new Set();
    if (!profile) return handles;

    (profile.products || []).forEach(add);
    if (profile.combo && Array.isArray(profile.combo.products)) {
      profile.combo.products.forEach(add);
    }

    return handles;

    function add(product) {
      if (product && product.handle) handles.add(product.handle);
    }
  }

  function scoreProduct(product, state, preferredHandles) {
    var score = 5;
    var pieceOption = getSelectedQuestionOption(state, 'piece');
    var budgetOption = getSelectedQuestionOption(state, 'budget');
    var styleOption = getSelectedQuestionOption(state, 'style');
    var momentOption = getSelectedQuestionOption(state, 'moment');
    var profileKey = state.result && state.result.profileKey;

    if (preferredHandles && preferredHandles.has(product.handle)) score += 24;
    if (profileKey) score += scoreKeywords(product, PROFILE_KEYWORDS[profileKey], 7);
    if (styleOption && STYLE_PROFILE_MAP[styleOption.value]) {
      score += scoreKeywords(product, PROFILE_KEYWORDS[STYLE_PROFILE_MAP[styleOption.value]], 5);
    }
    if (momentOption && MOMENT_KEYWORDS[momentOption.value]) {
      score += scoreKeywords(product, MOMENT_KEYWORDS[momentOption.value], 5);
    }

    if (pieceOption && pieceOption.typePreference) {
      if (pieceOption.typePreference === 'set') {
        score += product.isSet ? 70 : 0;
      } else if (matchesProductType(product, pieceOption.typePreference)) {
        score += 48;
      }
    }

    if (budgetOption && budgetOption.budget) {
      score += scoreBudget(product.price || 0, budgetOption.budget);
    }

    return score;
  }

  function filterProductsForAnswers(products, state, options) {
    var settings = options || {};
    var pieceOption = getSelectedQuestionOption(state, 'piece');
    var budgetOption = getSelectedQuestionOption(state, 'budget');

    return uniqueProducts(products).filter(function (product) {
      if (!isAvailableProduct(product)) return false;
      if (settings.applyPiece && pieceOption && pieceOption.typePreference) {
        if (pieceOption.typePreference === 'set' && !product.isSet) return false;
        if (pieceOption.typePreference !== 'set' && !matchesProductType(product, pieceOption.typePreference)) return false;
      }
      if (budgetOption && budgetOption.budget && !matchesBudget(product, budgetOption.budget)) return false;
      return true;
    });
  }

  function matchesBudget(product, budget) {
    if (!budget) return true;
    var price = product.price || 0;
    if (budget.max && price > budget.max) return false;
    return true;
  }

  function scoreKeywords(product, keywords, weight) {
    if (!keywords || !keywords.length) return 0;
    var text = getProductSearchText(product);
    var matches = 0;

    keywords.forEach(function (keyword) {
      if (text.indexOf(normalizeText(keyword)) !== -1) matches += 1;
    });

    return Math.min(matches, 5) * (weight || 1);
  }

  function scoreBudget(price, budget) {
    if (!price || !budget) return 0;
    var min = budget.min || 0;
    var max = budget.max || Infinity;

    if (price >= min && price <= max) return 18;
    if (price < min) {
      return Math.max(0, 12 - (min - price) / 100000);
    }
    if (price > max) {
      return Math.max(0, 12 - (price - max) / 100000);
    }
    return 0;
  }

  function matchesProductType(product, preference) {
    if (preference !== 'set' && product && product.isSet) return false;

    var haystack = normalizeText((product.type || '') + ' ' + (product.title || ''));
    var needles = {
      ring: ['yuzuk', 'ring'],
      earring: ['kupe', 'earring'],
      necklace: ['kolye', 'necklace'],
      bracelet: ['bileklik', 'bracelet'],
      set: ['set'],
    }[preference];

    if (!needles) return false;
    return needles.some(function (needle) {
      return haystack.indexOf(needle) !== -1;
    });
  }

  function getProductCategory(product) {
    if (!product) return null;
    if (product.isSet) return 'set';
    if (matchesProductType(product, 'ring')) return 'ring';
    if (matchesProductType(product, 'earring')) return 'earring';
    if (matchesProductType(product, 'necklace')) return 'necklace';
    if (matchesProductType(product, 'bracelet')) return 'bracelet';
    return null;
  }

  function getProductSearchText(product) {
    return normalizeText([
      product && product.title,
      product && product.type,
      product && product.description,
      product && Array.isArray(product.tags) ? product.tags.join(' ') : '',
      product && product.handle,
    ].join(' '));
  }

  function buildProductMap(config) {
    var map = new Map();
    (config.heroProducts || []).forEach(add);
    (config.catalogProducts || []).forEach(add);
    (config.setProducts || []).forEach(add);
    (config.profiles || []).forEach(function (profile) {
      (profile.products || []).forEach(add);
      if (profile.combo && Array.isArray(profile.combo.products)) {
        profile.combo.products.forEach(add);
      }
    });
    return map;

    function add(product) {
      if (product && product.handle) map.set(product.handle, product);
    }
  }

  function getProfile(config, key) {
    return (config.profiles || []).find(function (profile) {
      return profile.key === key;
    });
  }

  function getSelectedQuestionOption(state, key) {
    var question = QUESTIONS.find(function (item) {
      return item.key === key;
    });
    return question ? getSelectedOption(question, state.answers[key]) : null;
  }

  function getSelectedOption(question, value) {
    return (question.options || []).find(function (option) {
      return option.value === value;
    });
  }

  function uniqueProducts(products) {
    var seen = new Set();
    var result = [];

    (products || []).forEach(function (product) {
      if (!product || !product.handle || seen.has(product.handle)) return;
      seen.add(product.handle);
      result.push(product);
    });

    return result;
  }

  function isAvailableProduct(product) {
    return product && product.variantId && product.available;
  }

  function mapCatalogProduct(product) {
    if (!product || !product.handle) return null;

    var variant = ((product.variants || []).find(function (item) {
      return item && item.available;
    }) || (product.variants || [])[0]);
    if (!variant) return null;

    var title = product.title || '';
    var type = product.product_type || '';
    var tags = Array.isArray(product.tags) ? product.tags : [];
    var text = normalizeText(title + ' ' + type + ' ' + tags.join(' '));
    var image = (variant.featured_image && variant.featured_image.src) ||
      ((product.images || [])[0] && (product.images || [])[0].src) ||
      null;
    var price = Math.round(parseFloat(variant.price || '0') * 100);
    var isRing = text.indexOf('yuzuk') !== -1 || text.indexOf('ring') !== -1;
    var isSet = text.indexOf('set') !== -1;

    return {
      id: product.id,
      title: title,
      description: stripHtml(product.body_html || '').replace(/\s+/g, ' ').trim().slice(0, 220),
      handle: product.handle,
      url: joinProductUrl(product.handle),
      image: image,
      price: price,
      priceText: formatPrice(price),
      type: type,
      tags: tags,
      variantId: variant.id,
      available: Boolean(variant.available),
      isRing: isRing,
      isSet: isSet,
    };
  }

  function joinProductUrl(handle) {
    return '/products/' + encodeURIComponent(handle || '');
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, ' ');
  }

  function formatPrice(price) {
    var number = Math.max(0, Number(price || 0) / 100);
    return number.toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + 'TL';
  }

  function sameHandle(product) {
    return function (item) {
      return item && product && item.handle === product.handle;
    };
  }

  function takeRotated(products, count, offset) {
    if (!products.length) return [];
    var result = [];
    var start = Math.abs(offset || 0) % products.length;

    for (var i = 0; i < Math.min(count, products.length); i += 1) {
      result.push(products[(start + i) % products.length]);
    }

    return result;
  }

  function formatProductTitle(title) {
    var text = String(title || '').trim();
    if (!text) return 'Saway';
    return text.split('|')[0].trim() || text;
  }

  function formatProductDescription(description) {
    return String(description || '')
      .replace(/\s+/g, ' ')
      .replace(/([.!?])(?=\S)/g, '$1 ')
      .replace(/\. \. \./g, '...')
      .trim();
  }

  function normalizeImageUrl(url) {
    var value = String(url || '');
    if (value.indexOf('//') === 0) return 'https:' + value;
    return value;
  }

  function setStatus(scope, message, type) {
    if (!scope) return;
    var status = scope.querySelector('[data-mdgw-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', type === 'error');
    status.classList.toggle('is-success', type === 'success');
  }

  function setButtonLoading(button, loading, label) {
    if (!button) return;
    if (loading) {
      button.dataset.mdgwOriginalText = button.textContent;
      button.textContent = label || 'Bekleyin...';
      button.disabled = true;
      return;
    }

    if (button.dataset.mdgwOriginalText) {
      button.textContent = button.dataset.mdgwOriginalText;
      delete button.dataset.mdgwOriginalText;
    }
    button.disabled = false;
  }

  async function getResponseError(response) {
    var data = await response.json().catch(function () {
      return null;
    });
    return (data && (data.description || data.message || data.status)) || 'İşlem tamamlanamadı.';
  }

  function show(element, visible) {
    if (!element) return;
    element.hidden = !visible;
  }

  function loadState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function saveState(state) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      // The wizard remains usable without persistence.
    }
  }

  function ensureTrailingSlash(value) {
    var text = String(value || '/');
    return text.charAt(text.length - 1) === '/' ? text : text + '/';
  }

  function normalizeText(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function cssAttr(value) {
    return String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
